export enum ContentPageActions {
  Unused = 0,
  PageClosed = 1,
  RegistrationAccessed = 2,
  ViewProfile = 3,
  Help = 4,
  ReferralMadeGiven = 5,
  PageContentViewed = 6
}